var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPulldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#002445;}.b{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.181,1.17a1,1,0,0,1,1.638,0L12.9,8.427A1,1,0,0,1,12.079,10H1.921A1,1,0,0,1,1.1,8.427Z",
    transform: "translate(19 17) rotate(180)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPulldown);
export default __webpack_public_path__ + "static/media/icon_pulldown.e0ccedb11c2a0d0faede321c33277332.svg";
export { ForwardRef as ReactComponent };